
import Vue from "vue";
import { isValid, parseISO } from "date-fns";
import { maska } from "maska";

import { dateMask } from "./mask.utils";
import { formatDate, formatDateISO, parseDate } from "./format.utils";

export default Vue.extend({
  name: "DateInput",

  directives: { maska },

  props: {
    value: String,
    label: { type: String, required: true },
    allowedWeekDays: { type: Array, default: () => [0, 1, 2, 3, 4] },
    allowAll: { type: Boolean, default: false },
    error: String,
    disabled: Boolean,
    clearable: { type: Boolean, default: false },
    skipDays: { type: Number, default: 0 },
    daysLimit: { type: Number, default: 0 },
    byNow: { type: Boolean, default: false },
  },

  data: () => ({
    picker: false,
    date: "",
    innerError: "",
  }),

  computed: {
    mask: () => dateMask,

    hasErrors(): boolean {
      return this.error?.length > 0 || this.innerError?.length > 0;
    },

    formattedDate(): string {
      return this.date ? formatDate(this.date) : "";
    },
  },

  methods: {
    onInput(value: string, type: "picker" | "field" | "ISO") {
      this.picker = false;
      this.innerError = "";

      let date = value;

      if (type === "field") {
        try {
          if (value?.length >= 10) {
            const parsedDate = parseDate(value);
            if (!isValid(parsedDate)) {
              throw new Error();
            }

            date = formatDateISO(parsedDate);
          } else {
            date = "";
          }
        } catch (error) {
          this.innerError = "Data inválida";
          date = "";
          this.date = "";
        }
      }

      if (type == "ISO") {
        date = formatDateISO(value);
      }

      this.$emit("input", date);
    },

    showPicker() {
      this.date = formatDateISO(this.date);
      this.picker = !this.picker;
    },

    // permite apenas dias especificos da semana
    allowedDateFunction(date: string) {
      if (this.$props.allowAll) return true;
      const data = new Date(date);
      const today = new Date();

      // se for menor que hoje, não permite
      if (this.$props.byNow && data < today) return false;

      // se for maior que os dias limites, não permite
      if (
        this.$props.daysLimit > 0 &&
        data > new Date(today.setDate(today.getDate() + this.$props.daysLimit))
      )
        return false;

      return this.$props.allowedWeekDays.includes(data.getUTCDay());
    },
  },

  watch: {
    allowedWeekDays() {
      this.date = "";
      this.onInput(this.date, "ISO");
    },

    value(newValue) {
      const isString = typeof newValue === "string";
      const validDate = isString ? parseISO(newValue) : newValue;

      if (!newValue || isValid(validDate)) {
        this.date = newValue;
      }
    },
  },

  mounted() {
    this.date = this.value || "";
  },
});
